import type {
  ApiLanguage, CachedLangData, LangPack, LangPackStringValuePlural,
} from '../../api/types';

import readStrings from './readStrings';

const FALLBACK_LANG_CODE = 'en';
const FALLBACK_VERSION = 0;
const FALLBACK_TRANSLATE_URL = 'https://github.com/ansible-web/ansible-web';

export default async function readFallbackStrings(): Promise<CachedLangData> {
  const file = await import('../../assets/localization/fallback.strings?raw');
  return buildFallbackStrings(file.default);
}

export function buildFallbackStrings(fileData: string): CachedLangData {
  const rawStrings = readStrings(fileData);

  const strings: LangPack['strings'] = {};

  Object.entries(rawStrings).forEach(([key, value]) => {
    const [clearKey, pluralSuffix] = key.split('_');

    if (!pluralSuffix) {
      strings[clearKey] = value;
      return;
    }

    const knownValue = (strings[clearKey] || {}) as LangPackStringValuePlural;
    knownValue[pluralSuffix as keyof LangPackStringValuePlural] = value;
    strings[clearKey] = knownValue;
  });

  const langPack: LangPack = {
    langCode: FALLBACK_LANG_CODE,
    version: FALLBACK_VERSION,
    strings,
  };

  const stringsCount = Object.keys(strings).length;

  const language: ApiLanguage = {
    langCode: FALLBACK_LANG_CODE,
    name: 'English',
    nativeName: 'English',
    pluralCode: FALLBACK_LANG_CODE,
    stringsCount,
    translatedCount: stringsCount,
    translationsUrl: FALLBACK_TRANSLATE_URL,
  };

  return {
    langPack,
    language,
  };
}
